import DemoReportsTableItem from './DemoReportsTableItem'

export default DemoReportsTableItem
